import EntryForm from '../componets/Entry Form Management/EntryForm';
import Header from '../componets/Layout/Header';
import Sidebar from '../componets/Layout/Sidebar';

function EntryFormManagement({ tabledata }) {
  return (
    <>
      <div className='layouy-main'>
        <div className='sidebar-hide-show'>
          <Sidebar />
        </div>
        <div className='w-100'>
          <Header />
          <div className="tebs-title">
            <p className='active'>Entry Form Management</p>
          </div>
          <section>
            <div className="card main-card">
              <div className="card-body px-0 pt-0">
                <div className="table-main mb-4">
                  <div className="card">
                    <div className="card-body">
                      <EntryForm tabledata={tabledata} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  )
}

export default EntryFormManagement